
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","viewBox":"0 0 94 94"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#D0EFEC","fill-rule":"evenodd","d":"M49.384 18.696a2.25 2.25 0 0 1 2.08-1.392c3.212 0 6.3 1.255 8.583 3.501a11.92 11.92 0 0 1 3.57 8.605L63.08 40.7h16.318a8.95 8.95 0 0 1 3.7.762 8.85 8.85 0 0 1 3.056 2.233A8.7 8.7 0 0 1 87.983 47a8.65 8.65 0 0 1 .257 3.746l-3.905 28.578-.005.038a8.72 8.72 0 0 1-3.033 5.36 8.92 8.92 0 0 1-5.807 2.072H28.35a8.9 8.9 0 0 1-6.248-2.55 8.7 8.7 0 0 1-2.606-6.2V54.65c0-2.332.942-4.561 2.606-6.2a8.9 8.9 0 0 1 6.248-2.55h9.819z","clip-rule":"evenodd"}}),_c('path',{attrs:{"stroke":"#234652","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"2.791","d":"m32.554 41.048 12.41-30.102c2.765 0 5.417 1.081 7.373 3.006a10.18 10.18 0 0 1 3.053 7.256l-.684 14.367H74.38a7.05 7.05 0 0 1 2.925.599 6.95 6.95 0 0 1 2.4 1.752 6.8 6.8 0 0 1 1.43 2.582c.28.952.348 1.953.196 2.934l-4.112 30.1a6.8 6.8 0 0 1-2.37 4.187 7.02 7.02 0 0 1-4.581 1.629H20.633a7 7 0 0 1-4.915-2.004 6.79 6.79 0 0 1-2.036-4.838V47.89c0-1.815.732-3.555 2.036-4.838a7 7 0 0 1 4.915-2.004zm0 0H30.1v38.31"}})])
          )
        }
      }
    